<template>
  <div
    class="col mx-auto"
    style="width: 280px; height: 480px; background: red; border-radius: 10px;"
  >
    <div
      style="left:10px; top:10px; font-size: 50px;  padding-top: 20px; position: absolute; width: 260px; height: 100px; background: #9acfea; color: darkblue; text-align: center; border-radius: 5px"
    >
      {{ value || "[CODE]" }}
    </div>

    <div
      style="position: absolute; left: 0px; top: 110px; width: 280px; height: 370px;"
    >
      <div class="codeButton codeButtonX1 codeButtonY1" @click="add(1)">
        1
      </div>
      <div class="codeButton codeButtonX2 codeButtonY1" @click="add(2)">
        2
      </div>
      <div class="codeButton codeButtonX3 codeButtonY1" @click="add(3)">
        3
      </div>
      <div class="codeButton codeButtonX1 codeButtonY2" @click="add(4)">
        4
      </div>
      <div class="codeButton codeButtonX2 codeButtonY2" @click="add(5)">
        5
      </div>
      <div class="codeButton codeButtonX3 codeButtonY2" @click="add(6)">
        6
      </div>
      <div class="codeButton codeButtonX1 codeButtonY3" @click="add(7)">
        7
      </div>
      <div class="codeButton codeButtonX2 codeButtonY3" @click="add(8)">
        8
      </div>
      <div class="codeButton codeButtonX3 codeButtonY3" @click="add(9)">
        9
      </div>
      <div class="codeButton codeButtonX1 codeButtonY4" @click="bs()">
        &lt;
      </div>
      <div class="codeButton codeButtonX2 codeButtonY4" @click="add(0)">
        0
      </div>
      <div class="codeButton codeButtonX3 codeButtonY4" @click="ok()">
        OK
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "numPad",
  data: function() {
    return {
      value: ""
    };
  },
  mounted() {},
  methods: {
    add(s) {
      this.value += s;
      this.$emit("code", this.value);
    },
    bs() {
      let length = this.value.length;
      if (length > 0) {
        this.value = this.value.substring(0, length - 1);
      } else {
        this.$emit("code", this.value);
      }
    },
    ok() {
      this.$emit("ok", this.value);
    }
  },
  props: {}
};
</script>

<style scoped>
  .wcode {
    width: 280px;
  }

  .codeButton {
    width: 80px;
    height: 80px;
    font-size: 40px;
    border-radius: 10px;
    padding-top: 10px;
    position: absolute;
    background: #404040;
    color: white;
    text-align: center;
  }

  .codeButtonX1 {
    left: 10px;
  }

  .codeButtonX2 {
    left: 100px;
  }

  .codeButtonX3 {
    left: 190px;
  }

  .codeButtonY1 {
    top: 10px;
  }

  .codeButtonY2 {
    top: 100px;
  }

  .codeButtonY3 {
    top: 190px;
  }

  .codeButtonY4 {
    top: 280px;
  }

</style>
